import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Spisehuset from "./pages/Spisehuset";
import TakeawayCatering from "./pages/TakeawayCatering";
import SelskaberEvents from "./pages/SelskaberEvents";
import Julefrokost from "./pages/Julefrokost";
import Galleri from "./pages/Galleri";
import Kontakt from "./pages/Kontakt";

function App() {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = "Spisehuset i Værløse";
    const path = location.pathname;
    
    let pageTitle = baseTitle;
    
    if (path === "/") {
      pageTitle = baseTitle;
    } else if (path === "/spisehuset") {
      pageTitle = `${baseTitle} - Spisehuset`;
    } else if (path === "/takeaway-catering" || path === "/take-away" || path === "/catering") {
      pageTitle = `${baseTitle} - Take away & Catering`;
    } else if (path === "/selskaber-og-events") {
      pageTitle = `${baseTitle} - Selskaber og events`;
    } else if (path === "/selskaber-og-events/julefrokost") {
      pageTitle = `${baseTitle} - Julefrokost`;
    } else if (path === "/galleri") {
      pageTitle = `${baseTitle} - Galleri`;
    } else if (path === "/kontakt") {
      pageTitle = `${baseTitle} - Kontakt`;
    }
    
    document.title = pageTitle;
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="spisehuset" element={<Spisehuset />} />
        <Route path="takeaway-catering" element={<TakeawayCatering />} />
        <Route path="take-away" element={<TakeawayCatering />} />
        <Route path="catering" element={<TakeawayCatering />} />
        <Route path="selskaber-og-events" element={<SelskaberEvents />} />
        <Route path="selskaber-og-events/julefrokost" element={<Julefrokost />} />
        <Route path="galleri" element={<Galleri />} />
        <Route path="kontakt" element={<Kontakt />} />
      </Route>
    </Routes>
  );
}

export default App;
